export default __webpack_public_path__ + "static/media/section7-bg.b353ac5a.png";